<mat-card class="ecart-card">
  <mat-card-title>Détail de l'incident affranchi</mat-card-title>

  <mat-card-content *ngIf="typeEcart && valeurEcart !== null">
    <div class="comparison-container">
      @if (affranchi?.incidentAffranchi?.typeIncident?.codeTypeIncident ===
      'EBIT') {
      <ng-container [ngSwitch]="typeEcart">
        <!-- Poste -->
        <div *ngSwitchCase="'ecartPoste'" class="comparison-section">
          <h3>Postes</h3>
          <div class="comparison-grid">
            <div class="source">
              <label>BitDefender</label>
              <span>{{
                affranchi?.incidentAffranchi?.comparison?.bitData?.nbPostes
              }}</span>
            </div>
            <div class="source">
              <label>Divalto</label>
              <span>{{
                affranchi?.incidentAffranchi?.comparison?.divaltoData?.nbPostes
              }}</span>
            </div>
          </div>
          <div class="ecart-value">Écart : {{ valeurEcart }}</div>
        </div>

        <!-- Serveur -->
        <div *ngSwitchCase="'ecartServeur'" class="comparison-section">
          <h3>Serveurs</h3>
          <div class="comparison-grid">
            <div class="source">
              <label>BitDefender</label>
              <span>{{
                affranchi?.incidentAffranchi?.comparison?.bitData?.nbServeurs
              }}</span>
            </div>
            <div class="source">
              <label>Divalto</label>
              <span>{{
                affranchi?.incidentAffranchi?.comparison?.divaltoData
                  ?.nbServeurs
              }}</span>
            </div>
          </div>
          <div class="ecart-value">Écart : {{ valeurEcart }}</div>
        </div>
      </ng-container>
      }
    </div>
  </mat-card-content>
    <mat-card-content *ngIf="!typeEcart">
    <div
    *ngIf="affranchi?.incidentAffranchi?.deviceRg && affranchi?.incidentAffranchi?.deviceRg?.type?.code == 'POS'"
    class="comparison-section"
    style="margin-top: 16px"
  >
    <h3>Poste RG non présent dans BitDefender</h3>
    <div style="text-align: center;">
      {{ affranchi?.incidentAffranchi?.deviceRg?.nomAgent }}
    </div>
  </div>

  <div
    *ngIf="affranchi?.incidentAffranchi?.deviceRg && affranchi?.incidentAffranchi?.deviceRg?.type?.code == 'SERV'"
    class="comparison-section"
    style="margin-top: 16px"
  >
    <h3>Serveur RG non présent dans BitDefender</h3>
    <div style="text-align: center;">
      {{ affranchi?.incidentAffranchi?.deviceRg?.nomAgent }}
    </div>
  </div>

  <div
    *ngIf="affranchi?.incidentAffranchi?.deviceBit && affranchi?.incidentAffranchi?.deviceBit?.type?.code == 'POS'"
    class="comparison-section"
    style="margin-top: 16px"
  >
    <h3>Poste BitDefender non présent dans RG</h3>
    <div style="text-align: center;">
      {{ affranchi?.incidentAffranchi?.deviceBit?.nom }}
    </div>
  </div>

  <div
    *ngIf="affranchi?.incidentAffranchi?.deviceBit && affranchi?.incidentAffranchi?.deviceBit?.type?.code == 'SERV'"
    class="comparison-section"
    style="margin-top: 16px"
  >
    <h3>Serveur BitDefender non présent dans RG</h3>
    <div style="text-align: center;">
      {{ affranchi?.incidentAffranchi?.deviceBit?.nom }}
    </div>
  </div>

  <mat-card-content
    *ngIf="
      !typeEcart &&
      affranchi?.incidentAffranchi?.deviceBit == null && affranchi?.incidentAffranchi?.deviceRg == null &&
      (affranchi?.incidentAffranchi?.clientBitMissing != null || affranchi?.incidentAffranchi?.clientRgMissing != null)
    "
  >
    <div
      *ngIf="affranchi?.incidentAffranchi?.clientBitMissing != null"
      class="comparison-section"
      style="margin-top: 16px"
    >
      <h3>Client BitDefender non présent dans la table de correspondance</h3>
      <div style="text-align: center">
        {{ affranchi?.incidentAffranchi?.clientBitMissing }}
      </div>
    </div>

    <div
      *ngIf="affranchi?.incidentAffranchi?.clientRgMissing != null"
      class="comparison-section"
      style="margin-top: 16px"
    >
      <h3>Client RG non présent dans la table de correspondance</h3>
      <div style="text-align: center">
        {{ affranchi?.incidentAffranchi?.clientRgMissing }}
      </div>
    </div>
    <div class="comparison-section" style="margin-top: 16px">
      <h3>Description</h3>
      <div>
        {{ affranchi?.incidentAffranchi?.description }}
      </div>
    </div>
  </mat-card-content>


  </mat-card-content>

</mat-card>
